import React from 'react'
import "./LoadingWrapper.scss"

interface IProps {
    children?: any,
    isLoading?: boolean,
    style?: any,
    'data-attribute'?: any,
}

const index = (props: IProps) => {
    const { children, isLoading = true, style } = props
    const dataAttribute = props?.['data-attribute']


    if (isLoading) {
        return <div className="stage" style={style} data-attribute={dataAttribute}>
            <div className="dot-flashing"></div>
        </div>
    }

    if (React.isValidElement(children)) {
        return React.cloneElement(children as React.ReactElement<any>, {
            'data-attribute': dataAttribute,
        })
    }

    return <>{children}</>
}

export default index